import axios from "axios";
import { readFromLocalStorage } from "utils/helper";

const {
  REACT_APP_SVC_URL: baseURL,
  REACT_APP_REQUEST_TIMEOUT: timeout,
  REACT_APP_OIDC_AUTHORITY: authority,
  REACT_APP_API_KEY,
} = process.env;

let accessToken = REACT_APP_API_KEY;

const getUserAuth = () => {
  return readFromLocalStorage("userAccessToken");
};

export const controller = new AbortController();

const http = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    /* Authorization: `Bearer ${accessToken}` */
    api_key: accessToken,
  },
  timeout: timeout ? parseInt(timeout, 10) : 180000,
  signal: controller.signal,
});

// Add a request interceptor to dynamically set Authorization header
http.interceptors.request.use(
  (config) => {
    const userAuth = getUserAuth();
    if (userAuth) {
      config.headers.Authorization = userAuth;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

http.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    const json = error?.toJSON();
    return Promise.reject(error);
  }
);

export default http;
